module.exports = __webpack_public_path__ + "media/images/application/social_sharing/twitter-bdbb38351f72c8fde15101d173b68dea.png";